export var ApiPresenceStatus;
(function (ApiPresenceStatus) {
    ApiPresenceStatus["ONLINE"] = "ONLINE";
    ApiPresenceStatus["OFFLINE"] = "OFFLINE";
})(ApiPresenceStatus || (ApiPresenceStatus = {}));
export var ApiScope;
(function (ApiScope) {
    ApiScope["UNKNOWN"] = "UNKNOWN";
    ApiScope["VIEWER"] = "VIEWER";
    ApiScope["EDITOR_X"] = "EDITOR_X";
})(ApiScope || (ApiScope = {}));
